import React, { useContext, useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { apiGet, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import OInputField from 'components/reusable/OInputField'
import { preventMaxInput } from 'utils/validations'
import formValidation from 'utils/formValidation'

const Settings = () => {
  const { logoutUser } = useContext(AuthContext)
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { isDirty, errors }
  } = useForm({
    mode: 'onBlur',
    shouldFocusError: true,
    defaultValues: {}
  })
  const [settingChangeLoading, setSettingChangeLoading] = useState(false)
  const notification = useToastContext()

  const handleSubmitForm = async data => {
    try {
      setSettingChangeLoading(true)
      data.countryCode = +data?.countryCode?.slice(1)
      const res = await apiPut(apiPath.updateSettings, data)
      if (res.data.success === true) {
        notification.success(res?.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    } finally {
      setSettingChangeLoading(false)
    }
  }

  const getSettings = async () => {
    try {
      const res = await apiGet(apiPath.getSettings)
      if (res) {
        reset(res?.data?.results)
        setValue(
          'countryCode',
          res?.data?.results?.countryCode
            ? '+' + res?.data?.results?.countryCode
            : '+'
        )
      }
    } catch (error) {
      console.log('error:', error)

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  useEffect(() => {
    getSettings()
  }, [])

  const handleDecimalOffer = e => {
    var value = e.target.value
    setValue('countryCode', '+' + value.slice(1))
  }

  const codeValue = watch('email') ? watch('email') : ''

  const numericInputPattern = e => {
    if (['-', '+', 'e'].includes(e.key)) {
      e.preventDefault()
    }
  }

  return (
    <section className=''>
      <form onSubmit={handleSubmit(handleSubmitForm)} method='post'>
        <section className='sm:px-8 px-4 py-4 '>
          <div className='border xl:w-full round'>
            <header className='border-b  py-2 px-4 bg-gray-100 rounded-t-md '>
              <div className='font-semibold'>{t('WEB_SETTINGS')}</div>
            </header>
            <div className='bg-white py-6 px-4  rounded-b-md'>
              <main className='justify-center flex flex-wrap grid  lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-4'>
                <div className='w-full'>
                  <div className='flex'>
                    <OInputField
                      wrapperClassName='relative z-0 mb-6 w-full group'
                      type='text'
                      name='email'
                      id='email'
                      value={codeValue.toLowerCase()}
                      inputLabel={<>{t('O_EMAIL_ID')}</>}
                      maxLength={50}
                      onInput={e => preventMaxInput(e, 50)}
                      register={register('email', formValidation['email'])}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className='w-full'>
                  <div className='flex'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group'
                      type='text'
                      name='countryCode'
                      id='countryCode'
                      autoFocus={true}
                      inputLabel={
                        <>
                          {t('COUNTRY_CODE')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      onKeyDown={event => {
                        if (
                          !['Backspace', 'Delete', 'Tab'].includes(event.key) &&
                          !/[0-9]/.test(event.key)
                        ) {
                          event.preventDefault()
                        }
                      }}
                      placeholder=''
                      maxLength={4}
                      onInput={e => preventMaxInput(e, 4)}
                      register={register('countryCode', {
                        required: 'Please enter country code.',
                        min: {
                          value: 1,
                          message: 'Minimum value must is 1.'
                        },
                        onChange: e => handleDecimalOffer(e)
                      })}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className='w-full'>
                  <div className='flex'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group'
                      type='number'
                      name='mobile'
                      id='mobile'
                      inputLabel={<>{t('MOBILE_NUMBER')}</>}
                      maxLength={15}
                      onKeyDown={numericInputPattern}
                      onInput={e => preventMaxInput(e, 15)}
                      register={register('mobile', formValidation['mobile'])}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className='w-full'>
                  <div className='flex'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group'
                      type='number'
                      name='allowedHrs'
                      id='allowedHrs'
                      inputLabel={<>{t('ALLOWED_HOURS')}</>}
                      min={1}
                      onKeyDown={numericInputPattern}
                      onInput={e => preventMaxInput(e, 3)}
                      register={register(
                        'allowedHrs',
                        formValidation['allowedHrs']
                      )}
                      errors={errors}
                    />
                  </div>
                </div>
              </main>
            </div>
          </div>
        </section>
        <div className='mt-4 text-center'>
          {settingChangeLoading ? (
            <div
              className='max-w-[100px] block spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
              style={{ margin: '0 auto' }}
            >
              <div className='loading-spinner'></div>
            </div>
          ) : (
            <button
              disabled={!isDirty}
              className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
              type='submit'
            >
              {t('O_UPDATE')}
            </button>
          )}
        </div>
      </form>
    </section>
  )
}

export default Settings
